<template>
    <!-- BaseAppBar.vue -->
    <v-app-bar :color="color" :elevation="elevation" app clipped-left>
        <!-- The logo image -->
        <a href="/">
            <v-img
                :height="logoHeight"
                :src="logoSrc"
                :width="logoWidth"
                alt="Windsor Telecom Logo"
                contain
                position="left center"
            ></v-img>
        </a>

        <!-- The app bar title-->
        <v-toolbar-title class="primary--text">{{ title }}</v-toolbar-title>

        <!-- @slot default -->
        <slot></slot>
    </v-app-bar>
</template>

<script>
    import logo from '@windsor-telecom-management/client-core/src/assets/img/base-logo.svg'

    export default {
        name: 'BaseAppBar',
        props: {
            /**
             * The color of the bar
             */
            color: {
                type: String,
                default: 'white'
            },
            /**
             * The level of elevation to apply to the app bar
             */
            elevation: {
                type: Number,
                default: 1
            },
            /**
             * the height of the logo image
             */
            logoHeight: {
                type: Number,
                default: 40
            },
            /**
             * The width of the logo image
             */
            logoWidth: {
                type: Number,
                default: 60
            },
            /**
             * The src of the logo image
             */
            logoSrc: {
                type: String,
                default: logo
            },
            /**
             * The title of the app bar
             */
            title: {
                type: String,
                required: true
            }
        }
    }
</script>
